import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from 'ngx-store';
import { SessionService } from '../../service/session.service';
import { TaskService } from '../../service/tasks.service';
import { UserService } from '../../service/user.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;
    @LocalStorage('redirectTo') redirectTo: any;
    current: number = 0;
    max: number = 7;
    stroke: number = 15;
    radius: number = 125;
    semicircle: boolean = false;

    rounded: boolean = false;
    responsive: boolean = false;
    clockwise: boolean = true;
    color: string = '#622567';
    background: string = '#eaeaea';
    duration: number = 800;
    animation: string = 'easeOutCubic';
    animationDelay: number = 0;
    currentExp: string;
    page = 0
    isLogged: boolean;
    isSecondTest: boolean;
    animations: Array<string> = [
        'linearEase',
        'easeInQuad',
        'easeOutQuad',
        'easeInOutQuad',
        'easeInCubic',
        'easeOutCubic',
        'easeInOutCubic',
        'easeInQuart',
        'easeOutQuart',
        'easeInOutQuart',
        'easeInQuint',
        'easeOutQuint',
        'easeInOutQuint',
        'easeInSine',
        'easeOutSine',
        'easeInOutSine',
        'easeInExpo',
        'easeOutExpo',
        'easeInOutExpo',
        'easeInCirc',
        'easeOutCirc',
        'easeInOutCirc',
        'easeInElastic',
        'easeOutElastic',
        'easeInOutElastic',
        'easeInBack',
        'easeOutBack',
        'easeInOutBack',
        'easeInBounce',
        'easeOutBounce',
        'easeInOutBounce',
    ];
    gradient: boolean = false;
    realCurrent: number = 0;

    completedTasks = [];
    subjectId=[];
    users=[];
    admins=[];
    // tasks = [{task: "Demographics", completed: false},
    //          {task: "Covid", completed: false},
    //          {task: "WordCategorization", completed: false},
    //          {task: "FlashBeep", completed: false},
    //          {task: "Personality", completed: false},
    //          {task: "LoudnessPerception", completed: false},
    //          {task: "TargetDetection", completed: false},
    //          {task: "MovementPerception", completed: false}
    //          ]

    Demographic = false;
    Covid = false;
    WordCategorization = false;
    FlashBeep = false;
    Personality = false;
    LoudnessPerception = false;
    TargetDetection = false;
    MovementPerception = false;
    Quality = false;
    Fatigue = false;


    constructor(
        private sessionService: SessionService,
        private router: Router,
        public translate: TranslateService,
        private taskService: TaskService,
        private userService:UserService
    ) {
        this.isLogged = this.loggedUser && this.userData;

    }

    ngOnInit() {
     this.redirectTo ="/"
        if (this.isLogged) {
            this.taskService.getCompletedTasks().then((data: any) => {
                this.completedTasks = data.body;
                this.checkCompleted(this.completedTasks)
            })
        }

        this.userService.get_users_get().then((data: any) => {
            const helper = new JwtHelperService();
            const user = helper.decodeToken(this.loggedUser.access_token);
            console.log(user);
            // To allow second attempt on task

            // if(user.user_id.split("_")[1]!='1'){
            //         this.MovementPerception = true;
            //         this.FlashBeep = true;
            //         this.Personality = true;
            //         this.LoudnessPerception = true;
            //         this.TargetDetection = true;
            //         this.Demographic = true;
            //         this.Covid = true;
            //         this.Personality = true;
            //         this.Quality = true;
            //         this.Fatigue = true;     
            // }
        })

        this.userService.get_subject_id().then((data: any) => {
            this.subjectId=data.body;
            this.userService.get_admins().then((data: any) => {
                this.admins=data.body;
                this.userService.get_users_get().then((data: any) => {
                    this.users=data.body;
                    let max=-1;
                    for(let us1 in this.subjectId){
                        if(this.subjectId[us1].subject_id >= max){
                            max=this.subjectId[us1].subject_id;
                        }
                    }
                    for(let us in this.users){
                        let contr=0;
                        for(let us2 in this.subjectId){
                            if(this.subjectId[us2].id==this.users[us].id){
                                contr=1;
                            }
                        }
                        if(contr==0){
                            let contr1=0;
                            for(let ad in this.admins){
                                if(this.admins[ad].email==this.users[us].email){
                                    contr1=1;
                                }
                            }
                            if(contr1==0){
                                max=max+1;
                                let x={"id":this.users[us].id, "email":this.users[us].email, "subject_id":max}
    
                                this.userService.add_subject_id(x)
                            }
                            
                        }
                    }
                })
            })
            
        })
               
    }

    checkCompleted(completed) {
        const allowed = [
            "Covid", 
            "Fatigue", 
            "Quality", 
            "WordCategorization", 
            "FlashBeep", 
            "Personality", 
            "Demographic",
            "LoudnessPerception",
            "TargetDetection",
            "MovementPerception"
        ];

        completed.forEach(task => {
            if (allowed.includes(task)) {
                this[task] = true;
            }
        });

        // completed.forEach(t => {
        //     switch (t) {
        //         case "Demographic":
        //             this.Demographic = false;
        //             break;
        //         case "Covid":
        //             this.Covid = true;
        //             break;
        //         case "Personality":
        //             this.Personality = true;
        //             break;
        //         case "Quality":
        //             this.Quality = true;
        //             break;
        //         case "Fatigue":
        //             this.Fatigue = true;
        //             break;
        //         case "WordCategorization":
        //             this.WordCategorization = true;
        //             break;
        //         case "LoudnessPerception":
        //             this.LoudnessPerception = true;
        //             break;
        //         case "TargetDetection":
        //             this.TargetDetection = true;
        //             break;
        //         case "FlashBeep":
        //             this.FlashBeep = true;
        //             break;
        //         case "LoudnessPerception":
        //             this.LoudnessPerception = true;
        //             break;
        //         case "MovementPerception":
        //             this.MovementPerception = true;
        //             break;
        //     }
        // })
    }

    getOverlayStyle() {
        const isSemi = this.semicircle;
        const transform = (isSemi ? '' : 'translateY(-50%) ') + 'translateX(-50%)';

        return {
            top: isSemi ? 'auto' : '54%',
            bottom: isSemi ? '5%' : 'auto',
            left: '77%',
            transform,
            'font-size': this.radius / 3.5 + 'px',
        };
    }

    openPage() {
        //this.router.navigate(['/covid']);


        switch (this.page) {
            case 0:
                this.router.navigate(['/questionnaire'], { queryParams: { type: 'Demographic' } });
                break;
            case 1:
                this.router.navigate(['/questionnaire'], { queryParams: { type: 'Covid' } });
                break;
            case 2:
                this.router.navigate(['/memory-experiment']);
                break;
            case 3:
                this.router.navigate(['/flash-beep']);
                break;
            case 4:

                this.router.navigate(['/personality-survey']);
                break;
            case 5:
                this.router.navigate(['/loudness-perception']);
                break;
            case 6:
                this.router.navigate(['/target-detection']);
                break;
            case 7:
                this.router.navigate(['/movement-perception']);
                break;
            case 8:
                this.router.navigate(['/questionaire'], { queryParams: { type: "Quality" } });
                break;
            case 9:
                this.router.navigate(['/questionaire'], { queryParams: { type: "Fatigue" } });
                break;
        }

    }


    covid() {
        this.router.navigate(['/questionnaire'], { queryParams: { type: 'Covid' } });
    }

    memexp() {
        this.router.navigate(['/memory-experiment']);
    }

    flashBeep() {
        this.router.navigate(['/flash-beep']);
    }

    personality() {
        this.router.navigate(['/personality-survey']);
    }

    demographic() {
        this.router.navigate(['/questionnaire'], { queryParams: { type: 'Demographic' } });
    }

    quality() {
        this.router.navigate(['/questionnaire'], { queryParams: { type: 'Quality' } });
    }

    fatigue() {
        this.router.navigate(['/questionnaire'], { queryParams: { type: 'Fatigue' } });
    }

    loudnessPerception() {
        this.router.navigate(['/loudness-perception']);
    }

    targetDetection() {
        this.router.navigate(['/target-detection']);
    }

    movementPerception() {
        this.router.navigate(['/movement-perception'])
    }

    register() {
        this.router.navigate(['/register'])
    }
}
